// LATEST_LEGAL_VERSION — bump this whenever the markdown files in
// content/*.md change materially. The frontend posts this string to
// POST /api/v1/me/consent at signup so we have an audit record of
// which version each user originally accepted.
//
// Format: YYYY-MM-DD. Use the most-recent date among the three
// documents, applied uniformly across all three.
export const LATEST_LEGAL_VERSION = "2026-05-08";

// localStorage key the GoogleButton writes before redirecting to OAuth
// and the ConfirmHandler reads + clears on SIGNED_IN. Centralized here
// so a rename can't silently break the post-OAuth consent flush.
export const PENDING_CONSENT_KEY = "pending_consent_version";
